import { render } from "./NetworkErrorComponent.vue?vue&type=template&id=00a2ff04"
const script = {}
script.render = render

export default script